export { default } from './FloatingPanel';
